<div class="create_popup">
    <div class="modal-body">
        <form [formGroup]="createForm" class="mb-0">

            <div class="product-row mt-2">
                <div class="row">
                    <!-- <h3>General Info</h3> -->

                    <div class="col-md-12 col-sm-12 mb-3 ">
                        <div class="col-md-12">
                            <b>Name<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="name" /></span>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 mb-3 ">
                        <div class="col-md-12">
                            <b>Mobile<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="name" /></span>
                        </div>
                    </div>

                    <div class="col-md-12 col-sm-12 mb-3 ">
                        <div class="col-md-12">
                            <b>Email<span style="color:red">*</span>: </b>
                        </div>
                        <div class="col-md-12">
                            <span><input type="text" trim="blur" class="form-control"
                                    formControlName="email" /></span>
                        </div>
                    </div>

                    <button class="btn btn-primary mr-3" (click)="submitForm()">Submit</button>


                </div>
            </div>
        </form>
    </div>
</div>    
